import * as React from 'react';
import cn from 'clsx';
import { ArticleHeading1, ArticleHeading2, Button } from '@cian/ui-kit';
import { ComponentWithInnerHTML } from '@cian/frontend-e2e-deal-component';
import { ConditionalWrapper } from '@cian/conditional-component';

import { withDeviceType, IWithDeviceTypeProps } from '../../../../utils/withDeviceType';
import { IBonusModal } from '../../../../types/promoInfo/bonuses';

import * as styles from './styles.css';

interface IBonusModalContentProps extends IBonusModal, IWithDeviceTypeProps {
  onClose: () => void;
}

const BonusModalContent: React.FC<React.PropsWithChildren<IBonusModalContentProps>> = ({
  title,
  htmlContent,
  onClose,
  isPhone,
  deviceType,
}) => {
  return (
    <section className={cn(styles['container'], styles[deviceType])} data-testid="bonus-modal">
      <ConditionalWrapper if={isPhone} ThenComponent={ArticleHeading2} ElseComponent={ArticleHeading1} as="h2">
        {title}
      </ConditionalWrapper>
      <ComponentWithInnerHTML className={cn(styles['content'], styles[deviceType])} html={htmlContent} />
      <Button onClick={onClose} fullWidth={isPhone}>
        Понятно
      </Button>
    </section>
  );
};

const BonusModalContentWithDeviceType = withDeviceType(BonusModalContent);
export { BonusModalContentWithDeviceType as BonusModalContent };
